<template>
  <div
    id="tree-tabulator"
    ref="tableRef"
    class="table-report table-report--tabulator"
    :data-test="`${tableName}-data-table`"
  />
</template>

<script>
import { defineComponent, ref, reactive, onMounted, watch } from 'vue'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import axios from "axios";
import { useRoute, useRouter } from 'vue-router'
import toggleNestedTree from "@/utils/toggle-tree.js"

export default defineComponent({
  props: {
    dataArrayTable: {
      type: Array,
    },
    paginationSize: {
      type: Number,
      default: 10,
    },
    paginationSizeArray: {
      type: Array,
      default: () => [10, 20, 50, 100, 200, 500],
    },
    dataArray: {
      type: Array,
    },
    apiUrl: {
      type: String,
    },
    tableName: {
      type: String,
      default: "init"
    },
    routerName:{
      type: String
    },
    apiParams:{
      type: Object
    },
    totalList:{
      type: Number
    },
    methodRequest:{
      type: String
    },
    //ex. [{column:'cm_uid',dir:'asc'}] note* column must the same as field in columns setup option, use when set initial sort with field declared in columns setup option, choose only one initSorter or defaultSort
    initSorter:{
      type: Array,
      default: ()=>[]
    },
    //ex. [{field:'_id',dir:'asc'}] note* field is field name in database collection, use when set initial sort with field name does not declared in columns setup option
    defaultSort:{
      type: Array
    },
    //ex. [{column: 'name', relateColumn: ['surname']}] note* column must the same as field in columns setup option, relateColumn is other field name in db collection that you want to sort more, use for column concat with many field and sort with multiple field
    customSort:{
      type: Array,
      default: () => []
    },
    downloadCsv:{
      type: Boolean,
      default: false
    },
    downloadExcel:{
      type: Boolean,
      default: false
    },
    reportName:{
      type: String,
      default: 'รายงาน'
    }
  },
  setup(props, {emit}) {
    const tableRef = ref();
    const tabulator = ref();
    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        locale: "th-th",
        langs: {
          "th-th": {
            pagination: {
              page_size: "แสดง",
            },
          },
        },
        // data: props.dataArray,
        ajaxURL: `${process.env.VUE_APP_BASE_API}${props.apiUrl}`, //call api if using api no need to send dataArray
        ajaxConfig: props.methodRequest,
        ajaxParams: props.apiParams,
        ajaxRequestFunc: function(url, config, params){
          params.length = String(params.length)
          params.start = String(params.start)
          if(params.sorters.length > 0){
            for(let item of props.customSort){
              //find has custom column sort
              let customFilter = params.sorters.find(({field}) => field == item.column)
              //if has custom sort then push relate field to sorters
              if(customFilter){
                for(let relate of item.relateColumn){
                  params.sorters.push({field: relate, dir: customFilter.dir})
                }
              }
            }
          }else{
            //set default sort
            params.sorters = props.defaultSort
          }
          return axios.post(url, params).then(res => res.data)
        },
        ajaxResponse:function(url, params, response){
          document.querySelector(".totalList").innerHTML = response.recordsTotal
          return response; //return the tableData property of a response json object
        },
        pageLoaded: function(e, row){
          if(window.innerWidth > 1005){
            document.querySelectorAll(".tabulator-col").forEach((col)=>{
              if(col.style.display == 'none'){
                col.style.display = 'inline-block'
                col.setAttribute("hide","true")
              }
              //check cell field name equal to header column and set width
              document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
                if(cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field')){
                  cell.style.width = cell.style.width ? cell.style.width : cell.style.minWidth
                }
              })
            })
            document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
              if(cell.style.display == 'none')
                cell.style.display = 'inline-block'
            })
          }
        },
        initialSort: props.initSorter,
        // layout:"fitColumns",
        // responsiveLayout:'collapse',
        // pagination: 'local',
        pagination: 'remote',
        ajaxSorting:true,
        paginationDataSent:{
            "page":"start", //change page request parameter to "start"
            "size": "length",
        },
        paginationDataReceived:{
            "last_page":"maxPage", //change last_page parameter name to "maxPage"
        } ,
        headerSort:true,
        paginationSize: props.paginationSize,
        paginationSizeSelector: props.paginationSizeArray,
        cellVertAlign:"middle",
        placeholder:"ไม่มีข้อมูล",
        footerElement:`<span class="mb-1">ทั้งหมด <span class="totalList"></span> รายการ</span>`,
        columns: props.dataArrayTable,
        columnHeaderSortMulti:true,
        dataTree:true,
        dataTreeStartExpanded:false,
        downloadComplete: function(){
          emit("downloadCsvComplete")
          emit("downloadExcelComplete")
        },
        columnHeaderVertAlign:"bottom",
        renderComplete() {
          feather.replace({
            'stroke-width': 2
          })
        },
        maxHeight: 1000
      })
    }
    watch(()=> props.downloadCsv, (val)=>{
      if(val){
        toggleNestedTree(tabulator.value, "expand")
        tabulator.value.download("csv", `${props.reportName}.csv`);
        toggleNestedTree(tabulator.value, "collapse")
      }
    })
    watch(()=> props.downloadExcel, (val)=>{
      if(val){
        toggleNestedTree(tabulator.value, "expand")
        tabulator.value.download("xlsx", `${props.reportName}.xlsx`, {sheetName:"sheet1"});
        toggleNestedTree(tabulator.value, "collapse")
      }
    })
    /* var dataTreeCSVfileFormatter = function(columns, options, setFileContents){
       var fileContents = [];
        columns.forEach((row) => {
          console.log("each row", row);
          var item = [];

          switch(row.type){
              case "header":
                  //handle header rows

              case "group":
                  //handle group header rows

              case "calc":
                  //handle calculation rows

              case "row":
              //iterate over the columns in a row
              row.columns.forEach((col) => {
                // console.log("col",col);
                  if(col){
                      item.push(col.value);
                  }
              });

              fileContents.push(item.join(','));
              break;
          }
        });
        console.log(fileContents);
        setFileContents(fileContents.join("\n"), "text/csv");
    } */

    // Redraw table onresize
    const reInitOnResizeWindow = () => {

      window.addEventListener("resize", () => {
        tabulator.value.redraw();
        feather.replace({
          "stroke-width": 1.5,
        });
      });
    };

    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
      let xlsxScript = document.createElement('script')
      xlsxScript.setAttribute('src', 'https://oss.sheetjs.com/sheetjs/xlsx.full.min.js')
      document.head.appendChild(xlsxScript)
    })

    return {
      tableRef
    }
  }
})
</script>
<style lang="scss">
#tree-tabulator.tabulator {
  .tabulator-header{
    border-color: #aaa;
    .tabulator-headers{
      border-left: 1px solid #aaa;
      border-right: 1px solid #aaa;
      .tabulator-col{
        border-right-width: 1px;
        background-color: #214181 !important;
      }
    }
  }

  .tabulator-row {
    border-left-width: 1px;
    // border-right-width: 1px;
    border-color: #aaa;
    &.tabulator-row-odd{
      background: #f8f8f8;
    }
    .tabulator-cell{
      border-right-width: 1px;
      word-break: break-word;
      .tabulator-data-tree-control{
        background: rgb(33 65 129 / 85%);
        border: 1px solid rgb(33 65 129 / 85%);
        height: 13px;
        width: 13px;
        .tabulator-data-tree-control-expand{
          background: #FFF;
          border-left: 0;
          border-bottom: 0;
          &:after{
            background: #FFF;
          }
        }
        .tabulator-data-tree-control-collapse{
          &:after{
            background: #FFF;
          }
        }
      }
      .tabulator-data-tree-branch{
        border-left: 0;
        border-bottom: 0;
      }
    }
    &.tabulator-row-odd.tabulator-tree-level-1{
      background: #FFF;
      &:hover{
        background: #f5f6f8;
      }
    }
    &.tabulator-row-even.tabulator-tree-level-1{
      background: #FFF;
      &:hover{
        background: #f5f6f8;
      }
    }
  }
}



</style>
